import React, { useCallback } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import DragHandle from '@mui/icons-material/DragHandle';
import { List, ListItem } from '@mui/material';

interface DraggableListProps {
    id: string;
    items: any[];
    onOrderChange: (items: any[]) => void;
    renderItem: (items: any) => any;
    itemPadding?: number;
    disableDrag?: boolean;
}

function reorderItems(items: any[], source: number, destination: number) {
    const [removed] = items.splice(source, 1);
    items.splice(destination, 0, removed);
    return items;
}

const DraggableList: React.FC<DraggableListProps> = ({
    id,
    items,
    onOrderChange,
    renderItem,
    disableDrag = false
}) => {
    const handleDragEnd = useCallback(
        (result: any) => {
            // ignore if dropped outside the list
            if (!result.destination) {
                return;
            }
            const newItems = reorderItems(items, result.source.index, result.destination.index);

            onOrderChange(newItems);
        },
        [items]
    );

    return (
			<DragDropContext onDragEnd={handleDragEnd}>
				<Droppable droppableId={id}>
					{(provided) => (
						<List {...provided.droppableProps} ref={provided.innerRef}>
							{items.map((item, index) => (
								<Draggable draggableId={`draggable-${index}`} index={index} key={index} isDragDisabled={disableDrag}>
									{(provided) => (
										<ListItem {...provided.draggableProps} ref={provided.innerRef} sx={{padding: 0}}>
											{!disableDrag && (
												<div {...provided.dragHandleProps}>
													<DragHandle />
												</div>
											)}
											{renderItem(item)}
										</ListItem>
									)}
								</Draggable>
							))}
							{provided.placeholder}
						</List>
					)}
				</Droppable>
			</DragDropContext>
		)
};

export default DraggableList;